export const TEXT = {
  COPY_LINK_CTA: {id: 'raf.referrals.copy_cta'},
  SHARE_BY_SEND: {id: 'raf.referrals.share_cta'},
  MORE_INFO_LINK: {id: 'raf.mylk.moreinfo'},
};

export const TERMS_PUBLIC = '/help-and-contact/#referrals-how-it-works';
